import React, { useEffect, useState } from 'react'
import './pagination-filter.scss'
import RightArrowBlack from 'src/images/svg/icon-arrow-right-black'
import LeftArrowBlack from 'src/images/svg/icon-arrow-left-black'

interface PaginationFilterProps {
  currentPage: number
  totalPages: number
  isExpanded: boolean
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  isDesktop: boolean
  label: string
  setIsFallbackImgFilter: React.Dispatch<
    React.SetStateAction<
      Array<{
        label: string
        index: string
      }>
    >
  >
}

const PaginationFilter = ({
  currentPage,
  isExpanded,
  setCurrentPage,
  totalPages,
  isDesktop,
  label,
  setIsFallbackImgFilter,
}: PaginationFilterProps) => {
  const maxPages = isDesktop ? 5 : 4

  const getPageRange = () => {
    const halfMax = Math.floor(maxPages / 2)
    let start = currentPage - halfMax
    let end = currentPage + halfMax

    if (start < 1) {
      start = 1
      end = Math.min(totalPages, maxPages)
    }

    if (end > totalPages) {
      end = totalPages
      start = Math.max(1, totalPages - maxPages + 1)
    }

    return { start, end }
  }

  const [pageRange, setPageRange] = useState(getPageRange())

  const updatePageRange = () => {
    setPageRange(getPageRange())
  }

  useEffect(() => {
    setCurrentPage(1)
    updatePageRange()
  }, [isExpanded])

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
      updatePageRange()

      setIsFallbackImgFilter((rest) =>
        rest.filter((item) => item.label !== label)
      )
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
      updatePageRange()
      setIsFallbackImgFilter((rest) =>
        rest.filter((item) => item.label !== label)
      )
    }
  }

  const handleClickPage = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    updatePageRange()
    setIsFallbackImgFilter((rest) =>
      rest.filter((item) => item.label !== label)
    )
  }

  return (
    <div className="pagination">
      <LeftArrowBlack
        width="8"
        height="14"
        disabled={currentPage === 1}
        onClick={handlePreviousPage}
        viewBox="0 0 8 14"
        pathD="M7.1333 12.3333L1.79875 6.9987L7.1333 1.66658"
      />

      {Array.from({ length: pageRange.end - pageRange.start + 1 })?.map(
        (_, index) => {
          const pageNumber = pageRange.start + index

          return (
            <button
              key={pageNumber}
              onClick={() => handleClickPage(pageNumber)}
              disabled={pageNumber === currentPage}
              className="pagination-pageQuantity"
            >
              {pageNumber}
            </button>
          )
        }
      )}

      <RightArrowBlack
        width="8"
        height="14"
        disabled={currentPage === totalPages}
        onClick={handleNextPage}
        viewBox="0 0 8 14"
        pathD="M0.866699 1.66675L6.20125 7.0013L0.866701 12.3334"
      />
    </div>
  )
}

export default PaginationFilter
